import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { submit } from './modules'
import Loading from 'components/Loading'
import { queryNotice } from 'store/siteConfig'

export default function(route) {
  const SessionPay = Loadable({
    loader: () => import('./SessionPay'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          paymentsSessionPayState: state.paymentsSessionPayState,
          siteConfig: state.siteConfig,
        }),
        {
          submit,
          queryNotice,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/session-pay`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <SessionPay {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
